import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  @Input() cssClass: string;
  constructor(private router: Router) { }

  ngOnInit() {

  }

  goToPrivacyPolicy() {
    // this.router.navigate(['/privacy-policy']);
    window.open(window.location.origin + '/privacy-policy', '_blank');
  }

}
